import React from 'react';
import { Steps, Grid } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMenuItems, useNavigateConstructorTabs } from './hooks';
import { Title } from '@/components';
import { ProjectDto } from '@/core';
import classes from './ProjectsConstructorNavMenu.module.scss';

const { useBreakpoint } = Grid;

type PropsType = {
  projectData: ProjectDto;
};

export const ProjectsConstructorNavMenu = ({ projectData }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menuItems = useMenuItems(projectData);
  const screens = useBreakpoint();
  const isTabletScreen = !screens.xl;
  const { currentTabIndex } = useNavigateConstructorTabs(projectData);

  const handleOnChange = () => null;
  const handleClickOnStep = (tabName: string) => {
    const currentRoute = pathname.split('/');
    currentRoute.splice(-1, 1, tabName);
    navigate(currentRoute.join('/'));
  };
  return (
    <div className={isTabletScreen ? classes.navMenu__mobile : classes.navMenu}>
      <Title className={classes.title}>{isTabletScreen ? t('titleMobile') : t('title')}</Title>
      <div>
        <Steps direction="vertical" current={currentTabIndex} onChange={handleOnChange}>
          {menuItems.map((x) => (
            <Steps.Step onClick={() => !x.disabled && handleClickOnStep(x.key)} {...x} />
          ))}
        </Steps>
      </div>
    </div>
  );
};
